export default "__VITE_ASSET__f$Qzqg5a__"